import { render, staticRenderFns } from "./workerBatchForm.vue?vue&type=template&id=7151580b&scoped=true&"
import script from "./workerBatchForm.vue?vue&type=script&lang=js&"
export * from "./workerBatchForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7151580b",
  null
  
)

export default component.exports